import React from 'react'

// One broken add-on must never take the page with it, so each is drawn inside one of these.
export default class AddonErrorBoundary extends React.Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error) {
    console.error(`Add-on ${this.props.addon} crashed`, error)
  }

  render() {
    if (this.state.failed) {
      return <p className="text-xs text-gray-400 italic">This extra is unavailable right now.</p>
    }
    return this.props.children
  }
}
